module.exports = __webpack_public_path__ + "img/dpd.37a3e361.png";